import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingPhoto } from './types/Listing';

interface PhotoParams {
  format?: string;
  crop?: boolean;
}

export default (makeCall: MakeCall) =>
  (listingId: number, { format, crop }: PhotoParams) =>
    makeCall<ListingPhoto[]>(
      'GET',
      `${APIV2_URL}/listing/${listingId}/photos`,
      {
        query: { format, crop },
      },
    );
